module.exports = __webpack_public_path__ + "img/boy_right.5d671d1e.svg";